import 'core-js';
import * as jQuery from 'jquery';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Tabs } from './components/tabs/tabs';
import { Modal } from './components/modal/modal';
import { EventSchedule } from './components/event-schedule/event-schedule';
import { EventSearch } from './components/event-search/event-search';
import { Carousel } from './components/carousel/carousel';
import { Settings } from 'luxon';

Settings.defaultLocale = 'en-CA';

Settings.defaultZone = window['Barker'].config.timezone;

Settings.defaultWeekSettings = { firstDay: 7, minimalDays: 1, weekend: [6, 7] }


 jQuery(document).ready(
  ($) => {
    

    $('[data-barker-tabs]').each(
      (index, item) => {

        new Tabs($(item));

      }
    );

    $('[data-barker-modal]').each(
      (index, item) => {

        new Modal($(item), {});

      }
    );

    const body = $('body');

    $('[data-toggle-mobile-menu]').on(
      'click',
      () => {

        body.toggleClass('is-open-mobile-menu');

      }
    );


    $('[data-barker-event-search]').each(
      (index, item) => {

        const params = $(item).data('barker-event-search-options');

        ReactDOM.render(
          <EventSearch postTypes={ params.postTypes } />,
          item
        );

      }
    );

    $('[data-barker-schedule]').each(
      (index, item) => {
        ReactDOM.render(
          <MuiThemeProvider>
              <EventSchedule />
          </MuiThemeProvider>,
          item
        );
      }
    );

    $('[data-barker-select-change]').on(
      'change',
      function(e) {

        window.location.href = $(this).val() as string;

      }
    );

    $('[data-carousel]').each(
      (index, elem) => {
        new Carousel($(elem), {});
      }
    );

  }
);




// WEBPACK FOOTER //
// ./resources/src/theme.tsx